import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiAppLegacy, USER_PROFILE_QUERY_KEY } from '@/shared/api';

/**
 * 휴대폰번호 변경 mutation — 인증번호 확인 + 번호 변경 `PUT /users/me/mobile?code={code}`(구앱 정합). 발송
 * (`useSendMobileCodeMutation`) 후 사용자가 입력한 6자리 코드로 확정. 성공 시 프로필 무효화. 코드 오답/만료는
 * 에러 전파 → caller 가 문구 매핑. 후처리는 caller(SRP).
 */
export function useChangeMobileMutation() {
  const api = useApiAppLegacy();
  const queryClient = useQueryClient();

  return useMutation<void, Error, { mobile: string; code: string }>({
    mutationFn: async ({ mobile, code }) => {
      await api.user.updateMobile(code, { profile: { mobile } });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: USER_PROFILE_QUERY_KEY });
    },
  });
}
